import React from 'react';
import '../style/formGroupSelectInput.css'
import CustomSelect from "./General/customSelect";
import FormGroupPlainText from "./formGroupPlainText";

const FormGroupSelectInput = (props) => {
    const {isPlain, plainValue, onLabelClick, labelAsALink} = props;

    if(isPlain) {
        return (
            <FormGroupPlainText
                labelAsALink={labelAsALink}
                onLabelClick={onLabelClick}
                RightWrapper={props.RightWrapper}
                rightData={props.rightData}
                LeftWrapper={props.LeftWrapper}
                InputWrapper={props.CenterWrapper}
                Label={props.Label}
                Text={plainValue}
            />
        )
    }

    return (
        <div className="form-group">
            <div className={props.LeftWrapper}>
                <label className={"control-label text-left formGroupSelectInput-label" +
                (props.Required?' inputRequired':'')
                }>
                    {props.Label}
                    </label>
            </div>
            <div className={props.CenterWrapper}>
                <CustomSelect
                    multiple={props.Multiple}
                    required={props.Required}
                    disabled={props.Disabled}
                    name={props.Name}
                    onChange={props.HandleInputChange}
                    value={props.Value}
                    options={props.Options}
                />
            </div>
            <div className={props.RightWrapper}>{props.rightData?props.rightData:null}</div>
        </div>
    )
};

export default FormGroupSelectInput;